/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { FilePond, registerPlugin } from "react-filepond";

import { styled } from "@mui/material/styles";

import { EditorState, ContentState, convertFromHTML, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

import { convertToHTML } from "draft-convert";

import { Loading } from "notiflix/build/notiflix-loading-aio";
import { Block } from "notiflix/build/notiflix-block-aio";
import { Notify } from "notiflix/build/notiflix-notify-aio";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

import TextField from "@mui/material/TextField";

import Box from "@mui/material/Box";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { AddBox } from "@mui/icons-material";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Typography from "@mui/material/Typography";

import ControlledTextInput from "components/FormInputs/ControlledTextInput";
import ControlledDateTime from "components/FormInputs/ControlledDateTime";
import ControlledCheckbox from "components/FormInputs/ControlledCheckbox";
import ControlledSelect from "components/FormInputs/ControlledSelect";
import CustomInputs from "components/CustomInputs";
import { CustomSelect } from "components/CustomSelect";

//components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

//example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import { resellersSchema } from "../schemas/_model";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import Tooltip from "@mui/material/Tooltip";

import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";

import Alert from 'components/CustomAlert';

import AccountCircleIcon from "@mui/icons-material/AccountCircle";

// rtk queries
import {
  useGetAllStatesByCountryIdQuery
} from "services/countries";

import {
  usePostResellerMutation,
  useChangeProfileImageMutation
} from "services/resellers";

import { globalCountry } from "store/entities/countries";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function AddReseller({ companyId }) {

  const isEdit = false;

  const [file, setFile] = useState([]);

  const selectedCountry = useSelector(globalCountry);

  const [createReseller, { isLoading: isCreatingResellerLoading }] = usePostResellerMutation();

  const [changeProfileImage] = useChangeProfileImageMutation();
  // const { data: statesByCountryId = [], isLoading: isLoadingStates, isSuccess: isSuccessStates } = useGetAllStatesByCountryIdQuery(selectedCountry.id);

  const initialFormState = {
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    // address1: "",
    // address2: "",
    // state: ""
  };

  const { control, watch, handleSubmit, setValue, reset } = useForm({
    resolver: yupResolver(resellersSchema(isEdit)),
    defaultValues: initialFormState,
  });

  const [openResellerAdd, setOpenResellerAdd] = useState(false);

  const handleClickOpen = () => {
    setOpenResellerAdd(true);
  };
  const handleClose = () => {
    setOpenResellerAdd(false);
  };

  const onSubmit = async (data) => {
    // console.log(data)
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });

    delete data.address1;
    delete data.address2;

    data.avatar = "";

    try {
      const resellerResponse = await createReseller({ company_id: companyId, data: data });

      if(resellerResponse && resellerResponse.data?.status == "success") {
        Notify.success("Succefully Added!");
        if (file) {
          if(resellerResponse.data.response && resellerResponse.data.response.id) {
            let formData = new FormData();
            formData.append("file", file);
            await changeProfileImage({
              resellerId: resellerResponse.data.response.id,
              data: formData
            });
          }
        }
        handleClose();
      } else {
        if(resellerResponse.error?.data) {
          Notify.failure(resellerResponse.error.data.message);
        } else {
          Notify.failure("Something went wrong, Please try again!");
        }
      }
    } catch (e) {
    } finally {
      reset();
      Loading.remove(500);
    }
  };

  const handleUpdateFiles = (files) => {
    if (files.length > 0) {
      const photo = files[0].source;
      setFile(photo);
    } else {
      setFile([]);
    }
  };

  return (
    <>
      <MDButton variant="gradient" color="primary" sx={{ ml: 2 }} onClick={handleClickOpen}>
        Add Reseller
      </MDButton>
      <BootstrapDialog
        // onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        maxWidth="xl"
        sx={{
          "& .MuiPaper-root": {
            width: "900px",
          },
        }}
        open={openResellerAdd}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: "#3f3f3f" }} id="customized-dialog-title">
          Add Reseller
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <br />
          <form>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4} lg={4} xl={4}>
                <ControlledTextInput
                  name="email"
                  control={control}
                  labelText="Email *"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    type: "email",
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={4} lg={4} xl={4}>
                <ControlledTextInput
                  name="firstName"
                  control={control}
                  labelText="First Name *"
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={4} lg={4} xl={4}>
                <ControlledTextInput
                  name="lastName"
                  control={control}
                  labelText="Last Name *"
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={4} lg={4} xl={4}>
                <ControlledTextInput
                  name="phone"
                  control={control}
                  labelText="Phone *"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  // inputProps={{
                  //   type: "number",
                  // }}
                />
              </GridItem>

              <GridItem xs={12} sm={12}>
              <>
                <Box
                  component={FilePond}
                  sx={{
                    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
                    "& .filepond--file-action-button": {
                      cursor: "pointer",
                    },
                    "& .filepond--drop-label.filepond--drop-label label": {
                      fontSize: "13px",
                      letterSpacing: "0.5px",
                      fontWeight: "600",
                    },
                    mt: 2,
                  }}
                  instantUpload={false}
                  allowFileSizeValidation={true}
                  name="file"
                  allowFileTypeValidation={true}
                  acceptedFileTypes={[
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "image/webp"
                  ]}
                  allowMultiple={true}
                  allowFilePoster={false}
                  labelIdle={
                    'Drag & Drop avatar or <span class="filepond--label-action">Browse</span>'
                  }
                  onupdatefiles={handleUpdateFiles}
                  allowRevert={false}
                />
              </>
            </GridItem>

              <GridItem xs={12} sm={12} md={4} lg={4} xl={4}></GridItem>
            </GridContainer>
          </form>
        </DialogContent>
        <DialogActions>
          <MDButton
            type="submit"
            color="primary"
            variant="gradient"
            id="submit"
            onClick={handleSubmit(onSubmit)}
          >
            Add Reseller
          </MDButton>
          <MDButton color="secondary" variant="gradient" autoFocus onClick={handleClose}>
            Cancel
          </MDButton>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}

export default AddReseller;
